export enum EducationMethodEnum {
	FULL_TIME = 'full_time',
	EVENING = 'evening',
}
